import styled from 'styled-components';

export const Box = styled.button`
  display: flex;
  align-items: center;
  padding: 4px 12px 4px 8px;
  gap: 8px;
  height: 32px;
  background: ${(props) => props.theme.colors['neutral-20']};
  border-radius: 32px;
  transition: all 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
  &:hover {
    cursor: pointer;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.27);
    transition: all 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
  }
`;

export const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors['light-red']};
  svg {
    color: white;
    font-size: 13px;
  }
`;

export const Info = styled.p`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;
